import { useState, useRef } from 'react';

const CSS_VAR = '--sidebar-width';
const MIN = 320;
const MAX = 640;

const clamp = (v) => Math.min(MAX, Math.max(MIN, v));

export function useSidebarResize(initial = 320) {
  const [sidebarWidth, setSidebarWidth] = useState(initial);
  const [collapsed, setCollapsed]       = useState(false);
  const widthBeforeCollapse             = useRef(initial);

  // Keep the CSS var in sync with React state (initial paint + collapse restore)
  // This runs synchronously during render, so there's no flash.
  if (!collapsed) {
    document.documentElement.style.setProperty(CSS_VAR, `${sidebarWidth}px`);
  }

  const startResize = (e) => {
    if (collapsed) return;
    e.preventDefault();

    const onResize = (ev) => {
      const w = clamp(ev.clientX);
      // Update the DOM directly — no React re-render
      document.documentElement.style.setProperty(CSS_VAR, `${w}px`);
    };

    const stopResize = (ev) => {
      document.removeEventListener('mousemove', onResize);
      document.removeEventListener('mouseup', stopResize);
      // Commit to React state exactly once
      setSidebarWidth(clamp(ev.clientX));
    };

    document.addEventListener('mousemove', onResize);
    document.addEventListener('mouseup', stopResize);
  };

  const toggleCollapse = () => {
    setCollapsed(prev => {
      if (!prev) widthBeforeCollapse.current = sidebarWidth;
      else document.documentElement.style.setProperty(CSS_VAR, `${widthBeforeCollapse.current}px`);
      return !prev;
    });
  };

  const effectiveWidth = collapsed ? 0 : sidebarWidth;
  return { sidebarWidth: effectiveWidth, collapsed, toggleCollapse, startResize };
}